import { Component, OnInit } from "@angular/core";
import { ApiService } from "../../shared/services/api.service";
import { Urls } from "../../utils/urls";
import { MatSelectChange } from '@angular/material/select';
import moment from 'moment';
import { DomSanitizer } from "@angular/platform-browser";
import { DownloadFileService } from "@shared/services/download-file.service";
import saveAs from "file-saver";
import { Title } from '@angular/platform-browser';
@Component({
  selector: "app-latest-news",
  templateUrl: "./latest-news.component.html",
  styleUrls: ["./latest-news.component.scss"],
})
export class LatestNewsComponent implements OnInit {
  pageUrl!: string;

  newsList!: any[];

  newsMap: any = {};

  selectedNewsId!: number;

  isMobileView = false;

  public inProgress: boolean = false;

  constructor(private apiService: ApiService,
    private titleService: Title,
    public sanitizer: DomSanitizer,
    public downloadFileService: DownloadFileService) { }

  ngOnInit() {
    this.titleService.setTitle('Latest News | ITI Mutual Fund');
    this.pageUrl = location.href;
    this.readLatestNews();
  }

  public readLatestNews() {
    const obj = {
      type: "News",
      year: "",
      month: ""
    };
    this.apiService.postData(Urls.readArticles, obj).subscribe(
      (response) => {
        response.data.articles.forEach((article: any) => {
          if (article.video) {
            const link = "https://www.youtube.com/embed/";
            if (article.video.startsWith('https://www.youtube.com/watch?')) {
              const embed = article.video.split("watch?v=")[1];
              article.video = link + embed;
            } else if (article.video.startsWith("https://youtu.be/")) {
              const embed = article.video.split("https://youtu.be/")[1];
              article.video = link + embed;
            }
          }

          const diff = moment(article.modifiedDate, "DD-MM-YYYY, h:mm:ss").fromNow();
          article.translatedModifiedDate = `${diff} . Updated`;
          this.newsMap[article.id] = article;
        });
        this.newsList = response.data.articles || [];

        if (this.newsList[0]) {
          this.selectedNewsId = this.newsList[0].id;
        }
      },
      (error) => { }
    );
  }

  public downloadAsPDF(news: any) {
    if (news) {
      const name = news.split("/").pop();
      this.inProgress = true;
      this.downloadFileService.export(news).subscribe(
        data => {
          this.inProgress = false;
          const url = window.URL.createObjectURL(data);
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = name;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();

        }, error => {
          this.inProgress = true;
        });
    }
  }

  public onSelectionChange(change: MatSelectChange) {
    this.selectedNewsId = change.value;
  }
  public getSafeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  public downloadFile(path: string, name: string) {
    this.downloadFileService.export(path).subscribe(
      data => saveAs(data, name + `.pdf`)
    );
  };

  public selectTab(id: number) {
  this.selectedNewsId = id;

  setTimeout(() => {
    const tab = document.getElementById('tab-' + id);
    tab?.focus();
  });
}

public moveTab(direction: number) {
  if (!this.newsList?.length) {
    return;
  }

  const currentIndex = this.newsList.findIndex(
    item => item.id === this.selectedNewsId
  );

  let newIndex = currentIndex + direction;


  if (newIndex < 0) {
    newIndex = this.newsList.length - 1;
  }

  if (newIndex >= this.newsList.length) {
    newIndex = 0;
  }

  this.selectTab(this.newsList[newIndex].id);
}

}
